import { api } from "./api";

export const spacesList = async (params: { search?: string }): Promise<any> => {
  const { data } = await api.get("store/spaces", { params });
  return data;
};

export const spacesCreate = async (body: {
  name: string;
  description?: string;
}): Promise<any> => {
  const { data } = await api.post("store/spaces", body);
  return data;
};

export const spacesUpdate = async (body: {
  id: string | number;
  name: string;
  description?: string;
}): Promise<any> => {
  const { data } = await api.put("store/spaces/update", body);
  return data;
};

export const spacesDelete = async (body: {
  id: string | number;
}): Promise<any> => {
  const { data } = await api.put("store/spaces/delete", body);
  return data;
};
